let order_BillItemList = require("../../templates/order/BillItemList.handlebars");
let Backbone = require("backbone");
let _ = require("underscore");
let $ = require("jquery");
let BillItemModel = require("../../model/BillItemModel.js");
import POS from "../../POS.js";
let i18n = require("../../utils/i18n");
let {LogUtil} = require('../../utils/utils');
let i18next = require("i18next");
let moment = require("moment");
const uuid = require('uuid');

let main = function () {
    return Backbone.View.extend({
        windowWidth: null,
        mainHeight: null,

        events: {
            "click .pageUp": "onPrev",
            "click .pageDown": "onNext",
            "click button.remove": "onRemove",
            "click .billItem": "onSelectBillItem",
            "click .billItem .plus-btn": "onPlus",
            "click .billItem .minus-btn": "onReduce",
            "change .quantity": "_changeQuantity",
            "click .statusBox .edit-status": "_changeOrderStatus",
        },

        initialize: function () {
            if (!window.AndroidClient) {
                $(window).on("resize", () => {
                    this.windowWidth = null;
                    this.mainHeight = null;
                    this.render();
                });
            }
        },

        getSelectedBillItem: function(evt) {
            let selectedBillItem;
            let quantity;
            let from = null;

            if(_.isNumber(evt)) {
                selectedBillItem = this.model.get("collection").find(item => item.get('menuItem').id === evt);
                quantity = selectedBillItem.get('quantity');
                from = 'menu';
            } else {
                const target = $(evt.currentTarget);
                quantity = target.closest(".billItem").find('.info .quantity').text();
                const item = target.closest(".billItem");
                selectedBillItem = this.model.get("collection").findWhere({priority: item.data("priority")});
                from = 'billItemList';
            }

            return {selectedBillItem, quantity, from};
        },

        changeBillItemQuantity(selectedBillItem, quantity, delta, from) {
            selectedBillItem.setQuantity(parseInt(quantity) + delta);

            if (selectedBillItem.get("packageId")) {
                _.each(this.model.get("collection").where({packageId: selectedBillItem.get("packageId")}), function (pack) {
                    pack.setQuantity(parseInt(quantity) + delta);
                });
            }
            this.trigger("changeNumber", {menuItemId: selectedBillItem.attributes.menuItem.id, delta, from});
            const self = this;

            this.model.get('collection').models.forEach(function (billItem) {
                if (billItem.get('billItemModelId') == selectedBillItem.cid) {
                    billItem.setQuantity(billItem.getQuantity() + delta);
                    if (billItem.get("packageId")) {
                        _.each(this.model.get("collection").where({packageId: billItem.get("packageId")}), function (pack) {
                            pack.setQuantity(parseInt(quantity) + delta);
                        });
                    }
                    self.trigger("changeNumber");
                }
            });
        },

        onPlus: function (evt) {
            const {selectedBillItem, quantity, from} = this.getSelectedBillItem(evt);

            if (selectedBillItem.get('billItemModelId')) {
                return;
            }
            if (parseInt(quantity) > 9999) {
                alert("数量不能大于9999");
                return;
            }
            this.changeBillItemQuantity(selectedBillItem, quantity, 1, from);
        },

        // 通过点击相同菜品累加
        onPlusBySelect: function (menuItemId) {
            var self = this;
            this.model.get('collection').models.forEach(function (billItem) {
                // 判断菜品的id相同
                if (billItem.attributes.menuItem.id == menuItemId) {
                    billItem.setQuantity(billItem.getQuantity() + 1);
                    self.trigger("changeNumber");
                }
            });
        },

        _changeQuantity: function (evt) {
            var self = this;
            var target = $(evt.currentTarget);
            var item = target.closest(".billItem");
            var quantity = target.val();
            var selectedBillItem = this.model.get("collection").findWhere({priority: item.data("priority")});

            if (selectedBillItem.get('billItemModelId')) {
                return;
            }
            if (isNaN(quantity) || quantity == "") {
                alert("请输入数量");
                selectedBillItem.setQuantity(1);
                this.trigger("changeNumber");
                this.model.get('collection').models.forEach(function (billItem) {
                    if (billItem.get('billItemModelId') == selectedBillItem.cid) {
                        billItem.setQuantity(1);
                        self.trigger("changeNumber");
                    }
                });
                return;
            }
            if (parseInt(quantity) > 9999) {
                alert("数量不能大于9999");
                return;
            }
            if (parseInt(quantity) < 0) {
                alert("数量不能小于0");
                return;
            }
            selectedBillItem.setQuantity(parseInt(quantity));
            if (selectedBillItem.get("packageId")) {
                _.each(this.model.get("collection").where({packageId: selectedBillItem.get("packageId")}), function (pack) {
                    pack.setQuantity(parseInt(quantity) + 1);
                });
            }
            this.trigger("changeNumber");
            this.model.get('collection').models.forEach(function (billItem) {
                if (billItem.get('billItemModelId') == selectedBillItem.cid) {
                    billItem.setQuantity(billItem.getQuantity());
                    if (billItem.get("packageId")) {
                        _.each(this.model.get("collection").where({packageId: billItem.get("packageId")}), function (pack) {
                            pack.setQuantity(parseInt(quantity) + 1);
                        });
                    }
                    self.trigger("changeNumber");
                }
            });
        },

        onReduce: function (evt) {
            const {selectedBillItem, quantity, from} = this.getSelectedBillItem(evt);

            if (selectedBillItem.get('billItemModelId')) {
                return;
            }

            if (parseInt(quantity) < 0) {
                alert("数量不能小于0");
                return;
            }

            if (parseInt(quantity) - 1 > 0) {
                this.changeBillItemQuantity(selectedBillItem, quantity, -1, from);
            }
        },

        // 返回已经选择菜品
        getSelectedMenuItem:function () {
            var collection = this.model.get('collection');
            return collection;
        },

        addItem: function (params) {
            var collection = this.model.get('collection'),
                billItemModel,
                currentPriority = this.model.get("currentPriority") + 1;
            console.log("collection123;",collection);

            if (collection) {
                billItemModel = new BillItemModel({
                    menuItem: {id: params.menuItemId, name: params.name, categoryId: params.categoryId},
                    price: params.pricingSchemePrice || params.price,
                    quantity: params.quantity,
                    originalAmount: params.price,
                    priority: currentPriority,
                    dateCreated: new Date().getTime(),
                    hasRefund: false,
                    //billItemModelId: params.billItemModelId,
                    //packageItems: params.packageItems,
                    pricingSchemeItem: params.pricingSchemeItem
                });

                if (params.packageItems) {
                    billItemModel.set({packageId: uuid.v4()});
                }

                let packageItems = [];

                if (params.packageItems) {
                    console.log('params', params.packageItems);
                    packageItems = _.mapObject(params.packageItems, (items, optionName) => {
                        return items.map(item => {
                            console.log('item ', item);
                            item.categoryId = item.cateId;
                            return new BillItemModel({
                                menuItem: item,
                                price: 0,
                                quantity: 1,
                                originalAmount: 0,
                                dateCreated: new Date().getTime(),
                                hasRefund: false,
                                priority: ++currentPriority,
                                packageId: billItemModel.get('packageId'),
                                //packageBillItemModelId: billItemModel.cid,
                                isPackageItem: true,
                                packageOptionName: optionName
                            });
                        });
                    });
                }

                this.model.set("note", params.note);
                this.model.set("currentPriority", currentPriority);
                billItemModel.getAmount();
                let index = 0;
                collection.add(billItemModel, {at: index});

                if (packageItems) {
                    _.values(packageItems).forEach(items => {
                        items.forEach(bModel => collection.add(bModel));
                    });
                }
                this.model.set({offset: 0});
                this.render();
            }

            return billItemModel;
        },

        onPrev: function () {
            this.model.prev();
            this.render();
            this.trigger("changePage");
        },

        onNext: function () {
            this.model.next();
            this.render();
            this.trigger("changePage");
        },

        onRemove: function (event) {
            var selectedModel, billItemModelId, menuItemName;

            if (!event.target) {
                console.log("try to remove item", event);
                billItemModelId = event.billItemModelId;
                menuItemName = event.name;
                selectedModel = _.find(this.model.get("collection").models, function (billItem) {
                    return billItem.get('billItemModelId') == billItemModelId && billItem.get('menuItem').name === menuItemName;
                });

            } else {
                var self = this, priority = $(event.target).closest("li").data("priority");
                selectedModel = this.model.get("collection").findWhere({priority: priority});
                billItemModelId = selectedModel.get('billItemModelId');
                menuItemName = selectedModel.get('menuItem').name;
            }

            let packageItems = this.model.get('collection').filter(function (m) {
                return (m.get('packageId') === selectedModel.get('packageId') && selectedModel.get('packageId'));
            });

            if (packageItems) {
                const self = this;
                packageItems.forEach(function (m) {
                    m.destroy({
                        success: _.bind(function () {
                            this.trigger("removeBillItem");
                        }, self)
                    });
                })
            }

            selectedModel.destroy({
                success: _.bind(function () {
                    this.render();
                    this.trigger("removeBillItem");
                }, this)
            });

            if (billItemModelId) {
                //这个商品是添加标签是自动加入的，我们要删除原来商品上的标签
                var itemWithTag = _.find(this.model.get("collection").models, function (item) {
                    return item.cid == billItemModelId;
                });
                console.log('item with tag', itemWithTag);

                if (itemWithTag) {
                    var tag = _.find(itemWithTag.get('tags').models, function (t) {
                        return t.get('name').substring(1) == menuItemName;
                    });
                }

                if (tag) {
                    itemWithTag.get('tags').remove(tag.id);
                    console.log('new tags', itemWithTag.get('tags'));
                }
            }

            //删除商品时需要把相对应的标签商品也删除
            if (selectedModel && selectedModel.get('tags')) {
                _.filter(selectedModel.get('tags').models, function (tag) {
                    return tag.get('name').substring(0, 1) == '$'
                })
                    .forEach(function (tag) {
                        self.$('.billItem').each(function (i, ele) {
                            var billItem = $(ele);
                            if (billItem.find('.name').text().trim() == tag.get('name').substring(1)) {
                                console.log('found tag menu item', billItem);
                                billItem.find('.btn.remove').click();
                            }
                        })
                    });
            }
        },
        _changeOrderStatus: function (evt) {
            var self = this;
            var crtevt = $(evt.currentTarget);
            var item = crtevt.closest(".billItem");
            var selectedBillItem = this.model.get("collection").findWhere({priority: item.data("priority")});
            if (selectedBillItem.get('billItemModelId')) {
                return;
            }
            selectedBillItem.set({orderStatus: crtevt.data("type")});
            this.trigger("changeNumber");
            this.model.get('collection').models.forEach(function (billItem) {
                if (billItem.get('billItemModelId') == selectedBillItem.cid) {
                    billItem.set({orderStatus: crtevt.data("type")});
                    self.trigger("changeOrderStatus");
                }
            });
        },
        onSelectBillItem: function (event) {
            if ($(event.target).hasClass('edit-status') || ($(event.target).hasClass('edit-quantity') || $(event.target).hasClass('quantity')) || $(event.target).hasClass('remove') && $('.billItemEdit .closeBillItemEdit').size() == 0) {
                return;
            } else {
                var item = $(event.target).closest(".billItem");
                var selectedBillItem = this.model.get("collection").findWhere({priority: item.data("priority")});
                if (item.hasClass('selected')) {
                    this._hideItem(item);
                    this.trigger("selectBillItem", selectedBillItem, 'close');
                } else {
                    this._activeItem(item);
                    this.trigger("selectBillItem", selectedBillItem);
                }
            }
        },
        _activeItem: function (item) {
            this.$('.billItem.selected').find(".info").animate({left: 0}, 100);
            this.$('.billItem').removeClass('selected');
            item.addClass('selected');
            item.find(".info").animate({left: 10}, 100);
        },
        _hideItem: function (item) {
            this.$('.billItem.selected').find(".info").animate({left: 0}, 100);
            this.$('.billItem').removeClass('selected');
        },
        render: function (selectedCollection) {
            this.trigger("addItemFromPrv");
            var self = this;
            if (this.windowWidth <= 0) {
                this.windowWidth = $(window).width();
            }
            if (this.mainHeight <= 0) {
                this.mainHeight = $(".main").height();
            }

            let smallDevice = this.windowWidth <= 768;
            var viewHeight = this.mainHeight - (180 + 95 + (smallDevice ? 0 : 0));
            var pageSize = Math.floor(viewHeight / 60), note;
            this.model.set({pageSize: pageSize > 0 ? pageSize : 1});
            var billItemCount = 0, item;
            if (this.model.get("collection")) {
                this.model.get("collection").each(function (item) {
                    billItemCount += item.get("quantity");
                });
            }
            var billItemsJSON = this.model.getPageCollection().toJSON();
            $.each(billItemsJSON, function (i, v) {
                if (v.tags != null) {
                    v.tags = v.tags.toJSON();
                }
            });
            this.$el.html(order_BillItemList({
                billItems: billItemsJSON,
                billItemCount: billItemCount,
                maxPage: this.model.getMaxPage(),
                currentPage: this.model.get("offset") + 1,
                disabledNext: !this.model.hasNext(),
                disabledPrev: !this.model.hasPrev(),
                showPageInfo: this.model.showPage()
            }));
            note = this.model.get("note") ? this.model.get("note") : "";
            console.log("note", note);
            if (note) {
                this.$('.add-btn').hide().siblings('.pay-notes').css('display', 'block').show().find('.content').text(note);
            }

            var booking = this.model.get("booking") ? this.model.get("booking") : null;
            console.log("booking", booking);
            if (booking) {
                $('.add-booking .booking-btn').hide().siblings('.booking-notes')
                    .css('display', 'inline-table').show()
                    .find('.content')
                    .text(i18next.t("pos.booking.display", {
                        name: booking.name,
                        phone: booking.phone,
                        date: moment(booking.bookingDate).format("YYYY-MM-DD HH:mm"),
                        count: booking.adultCount + booking.childCount,
                        orderNo: booking.orderNo
                    }));
            }
            $('.submitBillBtn .bill-submit').attr('disabled', !billItemCount > 0);
            if (this.model.get("symbol")) {
                this.$(".symbol").html(this.model.get("symbol"));
            }

            return this;
        }


    });

};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/order/BillItemListView.js